module.exports = __webpack_public_path__ + "img/human-right.cf160a4d.png";